import { createSelector } from "@reduxjs/toolkit";
/**
 * Selector to get the entire dev features state.
 */
export const devFeaturesStateSelector = createSelector(state => state.devFeatures, devFeatures => {
  return {
    isTranslationOverrideAllowed: devFeatures.isTranslationOverrideAllowed,
    isSentryEnabled: devFeatures.isSentryEnabled,
    isProductFeedbackEnabled: devFeatures.isProductFeedbackEnabled
  };
});